<template>
  <div class="dynamic-box">
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <PopBook v-if="windowStatus">
        <template slot="header">
          <div class="pop-title">{{studyStage.title}}</div>
          <div class="pop-btn td-fsc">
            <img
              class="btn animated fadeInLeft"
              v-if="paused&&AutoBgMusic==1"
              @click="playBgMusic"
              src="../../../assets/img/grammarTest/music.png"
              alt
            />
            <img
              class="btn animated fadeInRight"
              v-else
              @click="playBgMusic"
              src="../../../assets/img/grammarTest/pause.png"
              alt
            />
            <img
              class="btn"
              @click="close"
              v-if="studyStage.courseType != 'qzfx'&&!isEnd"
              :src="GLOBAL.Images.dialog_quit"
              alt
            />
            <img
              class="btn"
              @click="close2"
              v-if="isEnd&&studyStage.courseType != 'qzfx'"
              :src="GLOBAL.Images.dialog_quit"
              alt
            />
            <audio
              id="bgMusic"
              :src="bgMusiceOpiton.memory_voice"
              :autoplay="bgMusiceOpiton.is_play==1"
            ></audio>
          </div>
        </template>
        <template slot="content">
          <component :is="component"
            ref="component"
            v-show="!isEnd"
            :dataSource="studyStage.dataSource"
            v-if="component"
            @quit="quit"
          />
          <Exit-Halfway
            v-if="isEnd"
            :dataSource="studyStage.dataSource"
            @keepStudy="keepStudy"
            @quit="quit"
          />
        </template>
      </PopBook>
    </transition>
  </div>
</template>

<script>
import { emptyOnceStudyNum } from "@/api/grammar";
import { mapState, mapGetters, mapMutations } from "vuex";
// import testResult from "./compel/testResult";
import ExitHalfway from "./ExitHalfway";
import Lockr from "lockr";

export default {
  name: "dynamic-link",
  props: ["data", "type", "windowStatus"],
  components: { ExitHalfway },
  data() {
    return {
      bgMusiceOpiton: "", //背景音乐
      component: null,
      dataSource: "",
      isEnd: false, //是否显示结果组件
      paused: true,
      AutoBgMusic: 1, //是否自动显示背景音乐
    };
  },
  methods: {
    ...mapMutations(["CHANGE_STUDY_TYPE"]),
    getBgMusicOption() {
      this.bgMusiceOpiton = Lockr.get("voiceOption");
    },
    //中途退出调出小结页面
    close() {
      if (this.studyStage.courseType == 'dyzthy') {
        this.$refs.component.goResult()
      } else {
        this.isEnd = true;
      }
    },
    close2() {
      this.isEnd = false;
      this.emptyOnceStudyNumFn();
      this.$emit("callBack", { type: "close" });
    },
    playBgMusic() {
      let buttonAudio = document.getElementById("bgMusic");
      if (buttonAudio.paused) {
        // 暂停中
        buttonAudio && buttonAudio.play();
        this.paused = true;
        this.AutoBgMusic = 1;
      } else {
        // 播放中
        buttonAudio && buttonAudio.pause();
        this.paused = false;
        this.AutoBgMusic = 2;
      }
    },
    //保存并推出
    quit() {
      this.isEnd = false;
      // this.emptyOnceStudyNumFn()
      this.$emit("callBack", { type: "close" });
    },
    //保存退出
    emptyOnceStudyNumFn() {
      let params = {
        token: Lockr.get("token"),
      };
      emptyOnceStudyNum(params);
    },
    keepStudy() {
      this.isEnd = false;
    },
  },
  computed: {
    ...mapGetters(["studyStage"]),
    loader() {
      // if (this.type=='') {
      //     return null
      // }
      return () => import(`./${this.type}`);
    },
  },
  watch: {
    type: {
      handler(newVal) {
        this.component = () => import(`./${newVal}`);
      },
      deep: true, // 必须加这个属性
    },
    windowStatus(newVal, oldVal) {
      if (newVal) {
        if (this.bgMusiceOpiton.is_play == 2) {
          this.AutoBgMusic = 2;
          this.paused = false;
        } else {
          this.AutoBgMusic = 1;
          this.paused = true;
        }
      }
    },
  },
  mounted() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {
        this.component = () => import("./demoPro");
      });
    this.getBgMusicOption();
  },
};
</script>

<style scoped lang='less'>
.dynamic-box {
  position: relative;
  z-index: 10;
}
.shade {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgb(0, 0, 0);
  opacity: 0.2;
  position: fixed;
  pointer-events: auto;
}
.dialog-box {
  width: 1000px;
  box-sizing: border-box;
  padding: 10px 10px 10px 25px;
  background-color: #416489;
  position: fixed;
  top: 50%;
  left: 50%;
  /*margin-left: -490px;*/
  /*margin-top: -425px;*/
  transform: translate(-50%, -50%);
  z-index: 1000;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  .dialog {
    height: 100%;
    min-height: 600px;
    border-radius: 16px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    position: relative;
    .dialog-title {
      padding: 20px 0px 10px;
      margin-left: 45px;
      margin-right: 20px;
      position: relative;
    }
    .dialog-content {
      flex: 1;
      margin: 10px 20px 10px 40px;
      overflow-y: auto;
      min-height: 450px;
      .component-box {
        min-height: 450px;
      }
    }
    .dialog-decorate {
      position: absolute;
      top: 20px;
      bottom: 20px;
      left: -15px;
      width: 46px;

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .topic-box {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}

.animated {
  animation-duration: 0.6s; //动画持续时间
}
@media (max-width: 1198px) {
  .dialog-box {
    width: 95%; 
  }
}
</style>
